"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_layout_1 = require("@carvana/helios-layout");
var helios_styles_1 = require("@carvana/helios-styles");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var TabContext_1 = __importDefault(require("./TabContext"));
var Container = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  border-bottom: 2px solid ", ";\n  color: ", ";\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  outline: inherit;\n  outline: none;\n  padding: 18px 24px 16px 24px;\n  text-align: center;\n\n  &[aria-selected='true'] {\n    border-bottom: 2px solid ", ";\n    font-weight: ", ";\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    box-shadow: 0px 0px 0px 3px rgba(34, 139, 230, 0.6),\n      0px 0px 0px 1px ", ";\n  }\n"], ["\n  background: none;\n  border: none;\n  border-bottom: 2px solid ", ";\n  color: ", ";\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  outline: inherit;\n  outline: none;\n  padding: 18px 24px 16px 24px;\n  text-align: center;\n\n  &[aria-selected='true'] {\n    border-bottom: 2px solid ", ";\n    font-weight: ", ";\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    box-shadow: 0px 0px 0px 3px rgba(34, 139, 230, 0.6),\n      0px 0px 0px 1px ", ";\n  }\n"])), helios_styles_1.background.mutedSubtle, helios_styles_1.text.default, helios_styles_1.heading.xs.fontFamily, helios_styles_1.heading.xs.fontSize, helios_styles_1.body.regular.xs.fontWeight, helios_styles_1.heading.xs.lineHeight, helios_styles_1.background.strong, helios_styles_1.heading.xs.fontWeight, helios_styles_1.text.strong, helios_styles_1.background.defaultHover, helios_styles_1.shadow.focusVisible[1].color);
var Tab = function (_a) {
    var children = _a.children, className = _a.className, tabGroup = _a.tabGroup, onClick = _a.onClick;
    var _b = (0, react_1.useContext)(TabContext_1.default), activeTab = _b.activeTab, idPrefix = _b.idPrefix, setActiveTab = _b.setActiveTab;
    var isClient = (0, helios_layout_1.useWindowLoaded)();
    var selected = activeTab === tabGroup;
    var handleClick = function () {
        if (onClick) {
            onClick();
        }
        setActiveTab(tabGroup);
    };
    var handleKeyDown = function (e) {
        if (e.code === 'Space' || e.code === 'Enter') {
            handleClick();
        }
    };
    return isClient ? ((0, jsx_runtime_1.jsx)(Container, __assign({ className: className, role: "tab", "aria-selected": selected, "aria-controls": "".concat(idPrefix, "-").concat(tabGroup, "-panel"), id: "".concat(idPrefix, "-").concat(tabGroup, "-tab"), onClick: handleClick, onKeyDown: handleKeyDown, "data-cv-test": "".concat(tabGroup, "-tab") }, { children: children }))) : null;
};
exports.default = Tab;
var templateObject_1;
